export const environment = {
  production: true,
  fileServiceURL: "https://files.input4you.be/api",
  backendURL: "https://gh-de.input4you.be/api",
  //backendURL: "http://localhost:56076/api",
  loginUrl: 'https://login.input4you.be/LoginAPI/'
};
